import React from 'react';
import {Button} from '@vkontakte/vkui';
import {Icon24ClockOutline} from '@vkontakte/icons';
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";

export function TournamentHistoryButton() {
    const routeNavigator = useRouteNavigator();

    const buttonHandler = () => {
        routeNavigator.push('/tournament-history');
    };

    return (
        <div className="flex w-full flex-col">
            <Button
                size="l"
                mode="primary"
                stretched
                onClick={buttonHandler}
                before={<Icon24ClockOutline/>}
                className="bg-yellow-400 hover:bg-yellow-500 text-gray-800 border-yellow-400"
            >
                Tournament history
            </Button>
        </div>
    );
}
